'use client'
import { PaymentSession } from '@medusajs/medusa'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js'
import React, { ReactNode } from 'react'
import LoadingIcon from '../../icons/LoadingIcon'
import appearance from './appearance'

type WrapperProps = {
    paymentSession?: PaymentSession | null
    children: ReactNode
}

const PaymentWrapper = ({ paymentSession, children }: WrapperProps) => {
    if (!paymentSession) {
        return <LoadingIcon />
    }

    switch (paymentSession.provider_id) {
        case 'stripe':
            return <StripeWrapper paymentSession={paymentSession}>{children}</StripeWrapper>

        default:
            return <div>{children}</div>
    }
}

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY || '', {
    locale: 'nl',
})

const StripeWrapper: React.FC<WrapperProps> = ({ paymentSession, children }) => {
    const options: StripeElementsOptions = {
        locale: 'nl',
        clientSecret: paymentSession!.data.client_secret as string | undefined,
        appearance,
        fonts: [
            {
                family: 'MMC',
                src: 'fonts/files/MMC-Medium.woff2',
                weight: '500',
            },
        ],
    }

    return (
        <Elements stripe={stripePromise} options={options}>
            {children}
        </Elements>
    )
}

export default PaymentWrapper
